// extracted by mini-css-extract-plugin
export default {"container":"container___M7roP","tabStyle":"tabStyle___yRWfv","tabsSpecial":"tabsSpecial___yk_ab","hiddenx":"hiddenx___nFlaT"};